function getPrice(price?: string | number): string | number {
  const parsedValue = Number(price);
  const rounding = Math.ceil(parsedValue);
  if (Number.isNaN(rounding)) return '';

  return rounding;
}

export default getPrice;
